import axios from 'axios';

export const fetchUrl = async (url: string, extraHeaders = {}): Promise<string> => {
  const response = await axios.get(url, { headers: { 'X-Alchemy-Request': 'true', ...extraHeaders } });
  return response?.data as string;
};
